import React from "react";
import {useHistory} from 'react-router-dom';
import {MessageDisplayerUtility} from "../common/MessageDisplayerUtility";
import {Constants} from "../common/Constants";
import {PillButton} from "../common/PillButton";
import {ApiUtility, LoginResponse} from "../common/ApiUtility";
import {RenderableData, useRenderableData} from "../common/hooks/useRenderableData";
import _ from "lodash";

interface LoginFormData extends RenderableData {
    username: string;
    password: string;
}

export let Login = function () {
    let history = useHistory();

    let renderableData: LoginFormData = useRenderableData({
        username: '',
        password: ''
    });

    function login(event: React.SyntheticEvent) {
        if (event) {
            event.preventDefault();
        }

        ApiUtility.login(renderableData.username, renderableData.password)
            .then(function (response: LoginResponse) {
                if (response.user) {
                    let permissionNames = _.map(response.permissions || [], 'name');

                    if (_.includes(permissionNames, Constants.permissionNames.canAccessWebAdmin)) {
                        if (response.qboAuthUrl) {
                            // redirect to QBO auth page
                            window.location.href = response.qboAuthUrl;
                        } else {
                            history.push('/');
                        }
                    } else {
                        MessageDisplayerUtility.error('User does not have web admin access.');
                    }
                } else {
                    MessageDisplayerUtility.error('Incorrect username or password.');
                }
            })
            .catch(function (errorMessage) {
                MessageDisplayerUtility.error(errorMessage);
            });
    }

    function handleTextFieldChange(fieldName: string, event: React.ChangeEvent<HTMLInputElement>) {
        renderableData.updateAndRender({[fieldName]: event.target.value});
    }

    return (
        <div className="login-page">
            <div className="login-page-content">
                <form
                    className="login-form"
                    onSubmit={login}
                >
                    <div className="login-box">
                        <div className="login-header">CULTIVATE BILLING</div>
                        <div className="login-subheader">
                            {`Version ${document.querySelector('.app-version')?.innerHTML || 'Unknown'}`}
                        </div>
                        <div className="login-field">
                            <input
                                id="usernameInput"
                                autoFocus={true}
                                className="common-form-input login-input"
                                type="text"
                                placeholder="Email Address"
                                onChange={(event) => handleTextFieldChange('username', event)}
                                value={renderableData.username}
                            />
                        </div>
                        <div className="login-field">
                            <input
                                id="passwordInput"
                                className="common-form-input login-input"
                                type="password"
                                placeholder="Password"
                                onChange={(event) => handleTextFieldChange('password', event)}
                                value={renderableData.password}
                            />
                        </div>
                        <button className="login-button">
                            <PillButton
                                onClick={login}
                                buttonText="LOGIN"
                            />
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
